import { Component, OnInit, Input } from '@angular/core';
import { NodoEntity, DatoEntity, TipoObjeto, ServicioFormatoAsistencialService, EstructuraNodo, FiltrosFormatoAsistencialEntity } from '../../../../services/servicio-formato-asistencial.service';
import { NodoService } from 'src/app/services/utils/nodo.service';

@Component({
  selector: 'app-matriz',
  templateUrl: './matriz.component.html',
  styleUrls: ['./matriz.component.css']
})
export class MatrizComponent implements OnInit {

  @Input() nodo: NodoEntity;
  @Input() filtros: FiltrosFormatoAsistencialEntity;

  titulo: string;
  html: string;
  htmlBuilder: string;
  ready: boolean;

  constructor(private servicioNodos: NodoService,
              private servicioFormato: ServicioFormatoAsistencialService) { }

  ngOnInit() {
    if (this.nodo) {
      if (this.nodo.datos && this.nodo.datos.length > 0) {
        this.titulo = this.nodo.titulo;
        this.ready = false;
        this.html = this.onMainProcess();
        this.ready = true;
      } else {
        if (this.filtros.diligenciados) {
          this.onDelete();
        } else {
          this.titulo = this.nodo.titulo;
          this.ready = false;
          this.html = this.onMainProcess();
          this.ready = true;
        }
      }
    } else {
      this.titulo = '';
    }
  }

  onMainProcess(): string {
    this.htmlBuilder = '';
    let colCount = 1;
    const config = this.servicioNodos.parseVal(this.nodo.valor);
    const map = this.servicioNodos.groupNodosByType(this.nodo.hijos);
    this.htmlBuilder += `<table style="width:100%;font-family:tahoma;" class="table-report">`;
    if (map && map[EstructuraNodo.Encabezado]) {
      this.htmlBuilder += `<tr><td style="width:190px;" class="table-cell table-header-cell table-cell-padding height-simple bg-light"></td>`;
      colCount = this.getColumnsForMatriz( map[EstructuraNodo.Encabezado]);
      this.htmlBuilder += '</tr>';
    }
    this.generateBody(this.nodo.hijos, map[EstructuraNodo.Encabezado], true, 1, colCount);
    this.htmlBuilder += '</table>';
    return this.htmlBuilder;
  }

  getColumnsForMatriz(nodos: NodoEntity[]): number {
    let count = 0;
    if (nodos && nodos.length > 0) {
      nodos.forEach((n: NodoEntity) => {
        let orientacion = true;
        let colSpan = 1;
        let rowSpan = 2;
        if (n.codigoTipoObjeto === TipoObjeto.SeleccionUnica) {
          orientacion = false;
          colSpan = n.hijos ? n.hijos.length : 0;
          rowSpan = 1;
        }
        this.getHeaderColumn(n, orientacion, rowSpan, colSpan);
        count += colSpan;
      });
    }
    return count;
  }

  getHeaderColumn(col: NodoEntity, orientacion: boolean, rowSpan: number, colSpan: number): void {
    this.htmlBuilder += `<th class="table-cell table-header-cell table-cell-padding text-center bg-light" rowspan="${rowSpan}" colspan="${colSpan}">`;
    this.htmlBuilder += col.titulo ? col.titulo : '';
    this.htmlBuilder += '</th>';
  }

  generateBody(nodos: NodoEntity[], columnas: NodoEntity[], first: boolean, counter: number, columnasSpan: number): number {
    if (nodos && nodos.length > 0) {
      for (let i = 0; i < nodos.length; i++) {
        const nodo = nodos[i];
        nodo.hijos = this.servicioFormato.getNodosHijos(nodo);
        if (nodo.codigoEstructura === EstructuraNodo.Grupo) {
          const config = this.servicioNodos.parseVal(nodo.valor);
          const titulo = nodo.titulo;
          this.htmlBuilder += '<tr>';
          this.htmlBuilder += `<th style="text-align:left" class="table-cell table-header-cell table-cell-padding">${titulo}</th>`;
            if (!first) {
              if (nodo.hijos.length >= 10) {
                this.getColumnsForGroup(columnas, true, true, false);
              } else {
                this.htmlBuilder += `<th class="table-cell table-header-cell table-cell-padding" colspan="${columnasSpan}"></th>`;
              }
            } else {
              this.getColumnsForGroup(columnas, false, true, true);
              first = false;
            }
            this.htmlBuilder += '</tr>';
          counter = this.generateBody(nodo.hijos, columnas, false, counter, columnasSpan);
        } else if (nodo.codigoEstructura === EstructuraNodo.Pregunta) {
          if (first) {
            this.htmlBuilder += '<tr>';
            this.htmlBuilder += `<th style="text-align:left" class="table-cell table-header-cell table-cell-padding bg-light"></th>`;
            this.getColumnsForGroup(columnas, false, true, true);
            this.htmlBuilder += '</tr>';
            first = false;
          }

          const titulo = nodo.titulo;
          titulo.replace('|#|', String(counter));
          this.htmlBuilder += '<tr>';
          this.htmlBuilder += `<td style="text-align:left" class="table-cell table-cell-padding">${titulo}</td>`;
          this.generateControl(nodo, columnas, false);
          this.htmlBuilder += '</tr>';
          counter++;
        }
      }
    }
    return counter;
  }

  getColumnsForGroup(nodos: NodoEntity[], showTitle: boolean, showTitleItems: boolean, first: boolean): Number {
    let count = 0;
    if (nodos && nodos.length > 0) {
      nodos.forEach((n: NodoEntity) => {
        if (n.codigoTipoObjeto === TipoObjeto.SeleccionUnica) {
          if (showTitleItems && n.hijos && n.hijos.length > 0) {
            n.hijos.forEach((h: NodoEntity) => {
              this.getHeaderColumn(h, true, 1, 1);
              count++;
            });
          }
        } else {
          if (!first) {
            this.htmlBuilder += `<th class="table-cell table-header-cell table-cell-padding bg-light">${showTitle ? n.titulo : ''}</th>`;
            count++;
          }
        }
      });
    }
    return count;
  }

  generateControl(nodo: NodoEntity, columnas: NodoEntity[], showTitle: boolean): void {
    if (nodo && columnas) {
      for (let i = 0; i < columnas.length ; i++) {
        const col = columnas[i];
        switch (col.codigoTipoObjeto) {
          case TipoObjeto.SeleccionUnica : {
            for (let j = 0; j < col.hijos.length ; j++) {
              const item = col.hijos[j];
              const selected: boolean = this.getDataSeleccionUnica(nodo.id, col.id, item.id);
              const el = selected ? `<i class="fa fa-check-circle-o"></i>` : `<i class="fa fa-circle-o"></i>`;
              this.htmlBuilder += `<td class="table-cell text-center">${el}</td>`;
            }
          } break;

          case TipoObjeto.ListaDesplegable : {
            const value = this.getDataListaDesplegable(nodo.id, col.id, col);
            this.htmlBuilder += `<td class="table-cell text-center">${value}</td>`;
          } break;

          case TipoObjeto.CuadroTexto : {
            const value = this.getDataTexto(nodo.id, col.id, col);
            this.htmlBuilder += `<td class="table-cell text-center">${value}</td>`;
          } break;
          default: {  } break;
        }
      }
    }
  }

  getDataSeleccionUnica(nodoRelacionado1: number, nodoRelacionado2: number, value: number): boolean  {
    const dato = this.nodo.datos.find((d: DatoEntity) => d.idNodoRelacionado1 === nodoRelacionado1 && d.idNodoRelacionado2 === nodoRelacionado2);
    if (dato)  {
      const valueSelected = Number(dato.valor);
      return valueSelected === value;
    }
    return false;
  }

  getDataListaDesplegable(nodoRelacionado1: number, nodoRelacionado2: number, columna: NodoEntity): string {
    if (this.nodo.datos) {
      const dato: DatoEntity = this.nodo.datos.find((d: DatoEntity) => {
        return d.idNodoRelacionado1 === nodoRelacionado1 && d.idNodoRelacionado2 === nodoRelacionado2;
      });

      if (dato) {
        try {
          const id: number = Number(dato.valor);
          if (id && columna.hijos && columna.hijos.length > 0) {
            const value: NodoEntity = columna.hijos.find((c: NodoEntity) => c.id === id);
            if (value) { return value.titulo; }
          }
        } catch (e) {
          console.error('Value ListaDesplegable.Matriz is not number?', e);
        }
      }
    }
    return 'no seleccionado';
  }

  getDataTexto(nodoRelacionado1: number, nodoRelacionado2: number, columna: NodoEntity): string {
    if (this.nodo.datos) {
      const dato: DatoEntity = this.nodo.datos.find((d: DatoEntity) => {
        return d.idNodoRelacionado1 === nodoRelacionado1 && d.idNodoRelacionado2 === nodoRelacionado2;
      });

      if (dato && dato.id) {
        return dato.valor || '';
      }
    }
    return '';
  }

  onDelete() { }

}
